module.exports = __webpack_public_path__ + "static/media/Flaticon.c1729513.svg";